module.exports = __webpack_public_path__ + "img/cta_6.c9a3f065.png";